"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorCode = void 0;
/**
 * User role enum defining different permission levels in the application
 */
exports.ErrorCode = {
  // Auth Errors
  AccessDenied: 'AccessDenied',
  AccountAlreadyConfirmed: 'AccountAlreadyConfirmed',
  AccountCredentialsExpired: 'AccountCredentialsExpired',
  AccountCredentialsInvalid: 'AccountCredentialsInvalid',
  AccountCredentialsNotConfirmed: 'AccountCredentialsNotConfirmed',
  AccountDoesNotExist: 'AccountDoesNotExist',
  AccountEmailAlreadyExists: 'AccountEmailAlreadyExists',
  AccountEmailInvalid: 'AccountEmailInvalid',
  AccountEmailNotConfirmed: 'AccountEmailNotConfirmed',
  AccountEmailOrGuidInvalid: 'AccountEmailOrGuidInvalid',
  AccountExternalCredentialsInvalid: 'AccountExternalCredentialsInvalid',
  AccountLockedOut: 'AccountLockedOut',
  AccountLockedOutOverride: 'AccountLockedOutOverride',
  AccountMagicUrlTokenExpired: 'AccountMagicUrlTokenExpired',
  AccountMagicUrlTokenInvalid: 'AccountMagicUrlTokenInvalid',
  AccountMagicUrlTokenMissing: 'AccountMagicUrlTokenMissing',
  AccountPasswordDoesNotMeetMinimumComplexity: 'AccountPasswordDoesNotMeetMinimumComplexity',
  AccountPasswordUsedPreviously: 'AccountPasswordUsedPreviously',
  AccountRequiresIdentityProviderApple: 'AccountRequiresIdentityProviderApple',
  AccountRequiresIdentityProviderGoogle: 'AccountRequiresIdentityProviderGoogle',
  AccountRequiresIdentityProviderLinkedIn: 'AccountRequiresIdentityProviderLinkedIn',
  AccountRequiresIdentityProviderLocal: 'AccountRequiresIdentityProviderLocal',
  AccountRoleInvalidForOperation: 'AccountRoleInvalidForOperation',
  AccountStatusInvalidForOperation: 'AccountStatusInvalidForOperation',
  AccountTombstoned: 'AccountTombstoned',
  AccountPasswordExpired: 'AccountPasswordExpired',
  AccountTelephoneNotVerified: 'AccountTelephoneNotVerified',
  AccountEmailNotVerified: 'AccountEmailNotVerified',
  AccountTelephoneOtpInvalid: 'AccountTelephoneOtpInvalid',
  AccountTelephoneOtpExpired: 'AccountTelephoneOtpExpired',
  AccountTelephoneDoesNotExist: 'AccountTelephoneDoesNotExist',
  AccountTelephoneOtpDoesNotExist: 'AccountTelephoneOtpDoesNotExist',
  AccountRequiredPropertiesMissing: 'AccountRequiredPropertiesMissing',
  EmailDoesNotExist: 'EmailDoesNotExist',
  EmailTrackingFailed: 'EmailTrackingFailed',
  InternalConfigurationError: 'InternalConfigurationError',
  TimedOut: 'TimedOut',
  UnhandledError: 'UnhandledError',
  UnknownError: 'UnknownError',
  // Imported errors
  ApplicationSettingsInvalid: 'ApplicationSettingsInvalid',
  Blacklisted: 'Blacklisted',
  CustomerCodeAlreadyExists: 'CustomerCodeAlreadyExists',
  CustomerCodeGenerationFailed: 'CustomerCodeGenerationFailed',
  CustomerDoesNotExist: 'CustomerDoesNotExist',
  CustomerDoesNotExistForAccount: 'CustomerDoesNotExistForAccount',
  CustomerInvalid: 'CustomerInvalid',
  CustomerNotFoundInToken: 'CustomerNotFoundInToken',
  CustomerVenueNotFound: 'CustomerVenueNotFound',
  CustomerVenueSpecialNotFound: 'CustomerVenueSpecialNotFound',
  EmailDeliveryFailed: 'EmailDeliveryFailed',
  EndpointDoesNotExist: 'EndpointDoesNotExist',
  EnumValueInvalid: 'EnumValueInvalid',
  FileNotFound: 'FileNotFound',
  GoogleJwtBearerTokenInvalid: 'GoogleJwtBearerTokenInvalid',
  GoogleJwtNonceInvalid: 'GoogleJwtNonceInvalid',
  GoogleCalendarAuthorizationFailed: 'GoogleCalendarAuthorizationFailed',
  GoogleCalendarNotConnected: 'GoogleCalendarNotConnected',
  AppleJwtBearerTokenInvalid: 'AppleJwtBearerTokenInvalid',
  AppleJwtNonceInvalid: 'AppleJwtNonceInvalid',
  InvalidRequest: 'InvalidRequest',
  JwtBearerTokenExpired: 'JwtBearerTokenExpired',
  JwtBearerTokenInvalid: 'JwtBearerTokenInvalid',
  JwtBearerTokenMissing: 'JwtBearerTokenMissing',
  JwtRefreshTokenExpired: 'JwtRefreshTokenExpired',
  JwtRefreshTokenBlacklisted: 'JwtRefreshTokenBlacklisted',
  JwtClaimInvalid: 'JwtClaimInvalid',
  JwtClaimNotPresent: 'JwtClaimNotPresent',
  JwtRoleInvalid: 'JwtRoleInvalid',
  JwtUnknownError: 'JwtUnknownError',
  MethodAttributeMissing: 'MethodAttributeMissing',
  ModelToDtoMappingNotSupported: 'ModelToDtoMappingNotSupported',
  ModelValidationFailed: 'ModelValidationFailed',
  NotImplemented: 'NotImplemented',
  NullReference: 'NullReference',
  ParameterCouldNotBeParsed: 'ParameterCouldNotBeParsed',
  ParameterCouldNotBeParsedToEnum: 'ParameterCouldNotBeParsedToEnum',
  RateLimitExceeded: 'RateLimitExceeded',
  RequestParameterNotExpectedInQueryString: 'RequestParameterNotExpectedInQueryString',
  RequiredParameterNullOrEmpty: 'RequiredParameterNullOrEmpty',
  ScheduledJobTimeout: 'ScheduledJobTimeout',
  AccountTelephoneRequiredForOtp: 'AccountTelephoneRequiredForOtp',
  AccountTelephoneInvalid: 'AccountTelephoneInvalid',
  AccountTelephoneAlreadyLinked: 'AccountTelephoneAlreadyLinked',
  AccountIdentityProviderAlreadyLinked: 'AccountIdentityProviderAlreadyLinked',
  AccountIdentityAlreadyExists: 'AccountIdentityAlreadyExists',
  AccountIdentityConflictTokenInvalid: 'AccountIdentityConflictTokenInvalid',
  AccountIdentityConflictTokenExpired: 'AccountIdentityConflictTokenExpired',
  AccountRoleInvalidForOtp: 'AccountRoleInvalidForOtp',
  AccountNotFoundInToken: 'AccountNotFoundInToken',
  AccountTelephoneAlreadyExists: 'AccountTelephoneAlreadyExists',
  GooglePlacesApiError: 'GooglePlacesApiError',
  GooglePlacesMaximumRequestsSent: 'GooglePlacesMaximumRequestsSent',
  GooglePlacesMaximumResultsReceived: 'GooglePlacesMaximumResultsReceived',
  GoogleCloudVisionApiError: 'GoogleCloudVisionApiError',
  RegistrationPhotoPersonNotDetected: 'RegistrationPhotoPersonNotDetected',
  RegistrationPhotoFaceQualityTooLow: 'RegistrationPhotoFaceQualityTooLow',
  RegistrationPhotoAdultContentDetected: 'RegistrationPhotoAdultContentDetected',
  RegistrationPhotoMinorDetected: 'RegistrationPhotoMinorDetected',
  RegistrationPhotoVerificationTokenMissing: 'RegistrationPhotoVerificationTokenMissing',
  RegistrationPhotoVerificationTokenInvalid: 'RegistrationPhotoVerificationTokenInvalid',
  RegistrationPhotoVerificationTokenExpired: 'RegistrationPhotoVerificationTokenExpired',
  RegistrationPhotoMismatch: 'RegistrationPhotoMismatch',
  ProfilePhotoUpdateAttemptLimitReached: 'ProfilePhotoUpdateAttemptLimitReached',
  RegistrationPhotoAttemptLimitReached: 'RegistrationPhotoAttemptLimitReached',
  PhotoVerificationAttemptDoesNotExist: 'PhotoVerificationAttemptDoesNotExist',
  PhotoVerificationAttemptNotEligible: 'PhotoVerificationAttemptNotEligible',
  GeographyWorldTileDoesNotExist: 'GeographyWorldTileDoesNotExist',
  VenueDoesNotExist: 'VenueDoesNotExist',
  VenueClosed: 'VenueClosed',
  VenueSpecialDoesNotExist: 'VenueSpecialDoesNotExist',
  VenueEventNotTicketed: 'VenueEventNotTicketed',
  VenueEventTicketPriceInvalid: 'VenueEventTicketPriceInvalid',
  VenueEventEnded: 'VenueEventEnded',
  TicketAlreadyPurchased: 'TicketAlreadyPurchased',
  TicketQuantityInvalid: 'TicketQuantityInvalid',
  TicketPaymentDeclined: 'TicketPaymentDeclined',
  TicketPaymentPending: 'TicketPaymentPending',
  TicketPaymentUnavailable: 'TicketPaymentUnavailable',
  TicketPriceChanged: 'TicketPriceChanged',
  TicketPurchasesDisabled: 'TicketPurchasesDisabled',
  TicketDoesNotExist: 'TicketDoesNotExist',
  RefundRequestDoesNotExist: 'RefundRequestDoesNotExist',
  RefundRequestNotEligible: 'RefundRequestNotEligible',
  RefundRequestAlreadyOpen: 'RefundRequestAlreadyOpen',
  RefundRequestAlreadyReviewed: 'RefundRequestAlreadyReviewed',
  RefundFailed: 'RefundFailed',
  RefundPending: 'RefundPending',
  SquareWebhookSignatureInvalid: 'SquareWebhookSignatureInvalid',
  PartneredHotspotDoesNotExist: 'PartneredHotspotDoesNotExist',
  PartneredHotspotInvalidDates: 'PartneredHotspotInvalidDates',
  PartneredHotspotOverlap: 'PartneredHotspotOverlap',
  VenueEventRsvpRequired: 'VenueEventRsvpRequired',
  VenueEventCommentDoesNotExist: 'VenueEventCommentDoesNotExist',
  VenueEventCommentAlreadyExists: 'VenueEventCommentAlreadyExists',
  VenueEventCommentEditForbidden: 'VenueEventCommentEditForbidden',
  VenueEventLikeAlreadyExists: 'VenueEventLikeAlreadyExists',
  VenueEventLikeNotFound: 'VenueEventLikeNotFound',
  VenueEventCommentLikeAlreadyExists: 'VenueEventCommentLikeAlreadyExists',
  VenueEventCommentLikeNotFound: 'VenueEventCommentLikeNotFound',
  VenueEventCommentCannotLikeOwn: 'VenueEventCommentCannotLikeOwn',
  VenueUserNotCheckedIn: 'VenueUserNotCheckedIn',
  VenueUserAlreadyCheckedIn: 'VenueUserAlreadyCheckedIn',
  VenueBreadcrumbDoesNotExist: 'VenueBreadcrumbDoesNotExist',
  VenueBreadcrumbRateLimitActive: 'VenueBreadcrumbRateLimitActive',
  VenueBreadcrumbCannotReactOwn: 'VenueBreadcrumbCannotReactOwn',
  VenueBreadcrumbReactionAlreadyExists: 'VenueBreadcrumbReactionAlreadyExists',
  VenueBreadcrumbReactionNotFound: 'VenueBreadcrumbReactionNotFound',
  VenueBreadcrumbReplyDoesNotExist: 'VenueBreadcrumbReplyDoesNotExist',
  VenueBreadcrumbReplyCannotReactOwn: 'VenueBreadcrumbReplyCannotReactOwn',
  VenueBreadcrumbReplyReactionAlreadyExists: 'VenueBreadcrumbReplyReactionAlreadyExists',
  VenueBreadcrumbReplyReactionNotFound: 'VenueBreadcrumbReplyReactionNotFound',
  VenueBreadcrumbEditForbidden: 'VenueBreadcrumbEditForbidden',
  VenueBreadcrumbDeleteForbidden: 'VenueBreadcrumbDeleteForbidden',
  VenueVisitPlanTimeSlotPassed: 'VenueVisitPlanTimeSlotPassed',
  VenueVisitPlanTimeSlotAlreadyTaken: 'VenueVisitPlanTimeSlotAlreadyTaken',
  VenueVisitPlanAlreadyExistsForDay: 'VenueVisitPlanAlreadyExistsForDay',
  VenueVisitPlanDoesNotExist: 'VenueVisitPlanDoesNotExist',
  VenueVisitPlanDateOutOfRange: 'VenueVisitPlanDateOutOfRange',
  VenueAutoCheckInDoesNotExist: 'VenueAutoCheckInDoesNotExist',
  VenueAutoCheckInWeekdaysInvalid: 'VenueAutoCheckInWeekdaysInvalid',
  VisitDoesNotExist: 'VisitDoesNotExist',
  ConversationDoesNotExist: 'ConversationDoesNotExist',
  PageDoesNotExist: 'PageDoesNotExist',
  UserDoesNotExist: 'UserDoesNotExist',
  UserNotCheckedInToVenue: 'UserNotCheckedInToVenue',
  UserNotCheckedInToSameVenue: 'UserNotCheckedInToSameVenue',
  UserNotAllowedToMessage: 'UserNotAllowedToMessage',
  UserCannotBlockSelf: 'UserCannotBlockSelf',
  UserCannotUnblockSelf: 'UserCannotUnblockSelf',
  UserCannotMessageSelf: 'UserCannotMessageSelf',
  UserCannotMessageNotLikedUser: 'UserCannotMessageNotLikedUser',
  UserAlreadyBlocked: 'UserAlreadyBlocked',
  UserAlreadyUnblocked: 'UserAlreadyUnblocked',
  UserNotCurrentlyBlocked: 'UserNotCurrentlyBlocked',
  UserCannotLikeSelf: 'UserCannotLikeSelf',
  UserCannotUnlikeSelf: 'UserCannotUnlikeSelf',
  UserNotCurrentlyLiked: 'UserNotCurrentlyLiked',
  UserAlreadyLiked: 'UserAlreadyLiked',
  UserCannotLikeUserDueToBlock: 'UserCannotLikeUserDueToBlock',
  UserCannotMessageUserDueToBlock: 'UserCannotMessageUserDueToBlock',
  UserNotFoundInToken: 'UserNotFoundInToken',
  UserCannotCheckInFromOutsideVenue: 'UserCannotCheckInFromOutsideVenue',
  UserCannotDeleteConversation: 'UserCannotDeleteConversation',
  UserCannotLookAtSelf: 'UserCannotLookAtSelf',
  ReferralCodeDoesNotExist: 'ReferralCodeDoesNotExist',
  ReferralCodeAlreadyRecordedForUser: 'ReferralCodeAlreadyRecordedForUser',
  TwilioMessageCreationFailed: 'TwilioMessageCreationFailed',
  OneSignalNotificationFailed: 'OneSignalNotificationFailed',
  InvalidDateOfBirthFormat: 'InvalidDateOfBirthFormat',
  InvalidTelephoneFormat: 'InvalidTelephoneFormat',
  InvalidNameFormat: 'InvalidNameFormat',
  NotificationBlastRadiusTooLarge: 'NotificationBlastRadiusTooLarge',
  IntentionDoesNotExist: 'IntentionDoesNotExist',
  IntentionLimitReached: 'IntentionLimitReached',
  UserIntentionRequiresCheckIn: 'UserIntentionRequiresCheckIn',
  MyPlacePinnedLimitReached: 'MyPlacePinnedLimitReached',
  MyPlaceDoesNotExist: 'MyPlaceDoesNotExist',
  FeedbackTopicDoesNotExist: 'FeedbackTopicDoesNotExist',
  FeedbackTopicClosed: 'FeedbackTopicClosed',
  FeedbackActiveTopicLimitReached: 'FeedbackActiveTopicLimitReached',
  FeedbackAttachmentInvalid: 'FeedbackAttachmentInvalid',
  FeedbackAttachmentTooLarge: 'FeedbackAttachmentTooLarge',
  FeedbackAttachmentLimitReached: 'FeedbackAttachmentLimitReached',
  AppStoreReviewDoesNotExist: 'AppStoreReviewDoesNotExist',
  AppStoreConnectNotConfigured: 'AppStoreConnectNotConfigured',
  VenueSuggestionDoesNotExist: 'VenueSuggestionDoesNotExist',
  VenueSuggestionAlreadyReviewed: 'VenueSuggestionAlreadyReviewed',
  StickerDoesNotExist: 'StickerDoesNotExist',
  StickerRateLimitActive: 'StickerRateLimitActive',
  StickerDeleteForbidden: 'StickerDeleteForbidden',
  StickerPhotoInvalid: 'StickerPhotoInvalid',
  StickerPhotoTooLarge: 'StickerPhotoTooLarge',
  ContentReportOwnContent: 'ContentReportOwnContent',
  EventbriteNotConfigured: 'EventbriteNotConfigured',
  EventbriteLinkInvalid: 'EventbriteLinkInvalid',
  EventbriteEventNotFound: 'EventbriteEventNotFound',
  EventbriteRequestFailed: 'EventbriteRequestFailed',
  EventbriteAuthorizationFailed: 'EventbriteAuthorizationFailed',
  EventbriteNotConnected: 'EventbriteNotConnected',
  /** The feature is switched off in Feature Flags (see AppFeature). */
  FeatureDisabled: 'FeatureDisabled'
};
//# sourceMappingURL=errorCodes.js.map